import React from 'react';
import DragNDropColumns from 'src/components/DragNDropColumns';
// import WarningIcon from 'src/components/Icon/Warning';
// import css from './css.module.less';
import ProductDisplayInRow from '@/src/components/DragRowDisplay/ProductDisplayInRowShort';
import { get } from 'lodash';
import { OriSelect } from 'src/components/Antd';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import { Field } from 'src/components/RcForm';
import ProductSelection from 'src/constrains/ProductSelectionNoPagination/GeneralSalesChannelProductSelection';
import { checkResponsiveProductTab } from 'src/constrains/SalesChannelContent-Revamp/ModuleList/validator';
import { useSalesChannelWithSisterProductSelectionUuid } from 'src/hooks/useSalesChannelWithSisterProductSelectionUuid';
import { ErrorDisplay2 } from 'src/constrains/SalesChannelPreviewPageComponents/CollapseErrors';
import { useI18n } from 'src/hooks/useRouterChange';
import { sectionProps } from 'src/tools/constant';
import {
  buttonThemeUuid,
  productToShow,
  products,
  tabs,
} from 'src/tools/contentModulesFieldName';
import { i18nGet } from 'src/tools/tools';
const Option = OriSelect.Option;
const ProductTabEdit = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const salesChannelUuid = useSalesChannelWithSisterProductSelectionUuid();
  const {
    disabled,
    options,
    buttons,
    index,
    tabDraggableId,
    onSort,
    onReselect,
    onDelete,
    breakpoint,
  } = props;
  const prefixName = [tabs, index];
  const [visible, setVisible] = React.useState(false);

  return (
    <React.Fragment>
      <Section {...sectionProps} id={tabDraggableId}>
        <ItemWrapper title={getI18n('general.productInARow')}>
          <Field name={[...prefixName, productToShow]}>
            <OriSelect disabled={disabled} size='large'>
              {options.map((i) => {
                const { label, value } = i;
                return (
                  <Option value={value} key={value}>
                    {label}
                  </Option>
                );
              })}
            </OriSelect>
          </Field>
        </ItemWrapper>
        <ItemWrapper title={getI18n('general.callToActionButtonTheme')}>
          <Field name={[...prefixName, buttonThemeUuid]}>
            <OriSelect disabled={disabled} size='large'>
              <Option value={null}>{getI18n('general.status.none')}</Option>
              {buttons.map((i) => {
                const { label, value } = i;
                return (
                  <Option value={value} key={value}>
                    {label}
                  </Option>
                );
              })}
            </OriSelect>
          </Field>
        </ItemWrapper>
        <Field
          shouldUpdate={(p, c) => {
            return (
              get(p, [...prefixName, products]) !==
                get(c, [...prefixName, products]) ||
              get(p, [...prefixName, productToShow]) !==
                get(c, [...prefixName, productToShow])
            );
          }}>
          {(props, meta, { getFieldValue, setFields, setFieldsValue }) => {
            const { checkEachTabCountError } = checkResponsiveProductTab();
            const tab = getFieldValue(prefixName);
            const res = checkEachTabCountError(tab, { breakpoint });
            const hasError = get(res, 'hasError');
            const errors = get(res, 'errors') || [];
            return hasError ? <ErrorDisplay2 err={errors} hasError /> : null;
          }}
        </Field>
      </Section>
      <Field name={[...prefixName, products]}>
        {(p, m) => {
          const { value, onChange } = p;
          const valueWithDraId = (value || []).map((i) => {
            return {
              ...i,
              draggableId: i.uuid,
            };
          });
          const handleOnItemReselect = (products) => {
            if (onReselect) {
              onReselect(valueWithDraId, onChange, products);
            }
          };
          const handleItemOnSort = (obj) => {
            const { data } = obj;
            const { newIndex, oldIndex } = data || {};
            if (onSort) {
              onSort(valueWithDraId, onChange, oldIndex, newIndex);
            }
          };
          const handleOnItemDelete = (index) => {
            if (onDelete) {
              onDelete(valueWithDraId, onChange, index);
            }
          };
          const childGenerate = (data, index) => {
            const sku = get(data, 'sku');
            const name = get(data, 'productName');
            const thumbnailUrl = get(data, 'thumbnailUrl');
            return (
              <ProductDisplayInRow sku={sku} name={name} img={thumbnailUrl} />
            );
          };
          return (
            <React.Fragment>
              {visible && (
                <ProductSelection
                  visible={visible}
                  onCancel={() => {
                    setVisible(false);
                  }}
                  onOk={handleOnItemReselect}
                  selectedProducts={valueWithDraId || []}
                  disabledProducts={[]}
                  salesChannelUuid={salesChannelUuid}
                />
              )}
              <DragNDropColumns
                // disabled={!isPrimary}
                // hideAdd={!isPrimary}
                hideTitle
                childGenerate={childGenerate}
                data={valueWithDraId || []}
                droppableId={`salesChannelContentListProductCarousel${tabDraggableId}`}
                onSort={handleItemOnSort}
                hideAdd={disabled}
                onAdd={() => {
                  setVisible(true);
                }}
                addText={`+ ${getI18n('general.addProduct')}`}
                onDelete={handleOnItemDelete}
              />
            </React.Fragment>
          );
        }}
      </Field>
    </React.Fragment>
  );
};
export default ProductTabEdit;
